import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown } from '@digdir/designsystemet-react';

import { useUser } from '../../../hooks/useUser';
import { camelCasify } from '../../../utils/navigation';

import { TitleProps } from './sideMenuButton';
import { MenuItem, StyledNavLink } from './styledComponents';

export const DropDownMenuItem: FC<TitleProps> = ({ tab }) => {
  const { t } = useTranslation();
  const { user } = useUser();

  const buttonText = t(`buildingScreen.tab.${camelCasify(tab)}.tabTitle`, {
    context: user?.type
  });

  return (
    <Dropdown.Item>
      <StyledNavLink to={tab} aria-label={buttonText}>
        {({ isActive }) => <MenuItem isActive={isActive}>{buttonText}</MenuItem>}
      </StyledNavLink>
    </Dropdown.Item>
  );
};
